import { createContext, useState, useContext, useEffect } from 'react';

const ThemeContext = createContext();

const themes = {
  light: {
    name: 'Light',
    icon: 'bi bi-sun',
    colors: {
      bgColor: '#f6f9ff',
      headerBg: '#fff',
      sidebarBg: '#fff',
      textColor: '#012970',
      textSecondary: '#666',
      borderColor: '#eee',
      cardBg: '#fff',
      hoverBg: '#f6f9ff',
      activeBg: '#7c5cfc',
      activeText: '#fff',
      chartColors: ['#7c5cfc', '#36b9cc', '#4e73df', '#1cc88a', '#f6c23e']
    }
  },
  dark: {
    name: 'Dark',
    icon: 'bi bi-moon',
    colors: {
      bgColor: '#1a1a1a',
      headerBg: '#2b2b2b',
      sidebarBg: '#2b2b2b',
      textColor: '#fff',
      textSecondary: '#b3b3b3',
      borderColor: '#404040',
      cardBg: '#2b2b2b',
      hoverBg: '#333',
      activeBg: '#7c5cfc',
      activeText: '#fff',
      chartColors: ['#7c5cfc', '#36b9cc', '#4e73df', '#1cc88a', '#f6c23e']
    }
  },
  blue: {
    name: 'Blue',
    icon: 'bi bi-droplet',
    colors: {
      bgColor: '#f0f7ff',
      headerBg: '#1a73e8',
      sidebarBg: '#fff',
      textColor: '#1a73e8',
      textSecondary: '#5f6368',
      borderColor: '#e8f0fe',
      cardBg: '#fff',
      hoverBg: '#e8f0fe',
      activeBg: '#1a73e8',
      activeText: '#fff',
      chartColors: ['#1a73e8', '#34a853', '#fbbc04', '#ea4335', '#46bdc6']
    }
  }
};

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'light';
  });

  useEffect(() => {
    const root = document.documentElement;
    const colors = themes[currentTheme].colors;
    
    Object.entries(colors).forEach(([key, value]) => {
      root.style.setProperty(`--${key}`, value);
    });
    
    localStorage.setItem('theme', currentTheme);
    document.body.setAttribute('data-theme', currentTheme);
  }, [currentTheme]);

  return (
    <ThemeContext.Provider value={{ 
      currentTheme, 
      setCurrentTheme,
      themes 
    }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext); 